HybridOption = App.loadClass 'grower::classes/placement/HybridOption'
PlantingPlanFactory = App.loadClass 'grower::viewmodels/placement/seed_options/PlantingPlanFactory'
PlantingToRxConverter = App.loadClass 'grower::viewmodels/placement/seed_options/PlantingToRxConverter'
RxPlanFactory = App.loadClass 'grower::viewmodels/placement/seed_options/RxPlanFactory'

class exports.Form extends KoModel

    setInitialDeps: () ->
        super()
        @syncDeps
            'Seed_Options_Field': 'grower::viewmodels/placement/seed_options/Field'


    constructor: (handler) ->
        super()

        @handler = handler
        @selectionsKO = handler.selectionsKO
        @writer = $(@handler.parent.layoutSelector).find('.message_writer')

        # SPP
        @spp = handler.parent
        @taffy = @spp.taffyObjects
        @spp_id = @spp.sppID
        @results_id = @spp.resultID

        # fields
        @fields = []
        @initialVisibleFieldNum = 0

        # result buttons
        @btnContents = @spp.hybridButtonContents
        @numResults = @spp.numVisibleResults
        @spanCls = 'span' + Math.round(12 / @numResults)

        @_initFields()

        @_initKO()


    #########################################################
    # Populate @fields and @fields.aspects
    #########################################################
    _initFields: () ->
        @taffy.fields().filter(selected: true).each (field) =>

            # create the knockout object
            fieldKO = new (@getDep 'Seed_Options_Field')(field, this)

            # field number
            fieldKO.field_num = @fields.length
            if field.id is @spp.currentFieldID
                @initialVisibleFieldNum = fieldKO.field_num

            # survey details
            fieldKO.setSurveyDetails(@handler.data.survey_details_by_field[field.id])

            # selections
            if field.planting_plan_id? and field.planting_plan_hybrids?
                # add the planting plan info to the KO object
                fieldKO.setPlantingPlan field.planting_plan_id,
                    field.planting_plan_hybrids,
                    @taffy.hybrids,
                    @selectionsKO,
                    false

            else if field.rx_plan_id? and field.rx_plan_hybrids?
                # add the rx plan info to the KO object
                fieldKO.setRxPlan field.rx_plan_id,
                    field.hidden_planting_plan_id,
                    field.rx_plan_hybrids,
                    @taffy.hybrids,
                    @selectionsKO,
                    false

            else
                if field.hybrids_id?
                    ho = new HybridOption({ id: field.hybrids_id }, @taffy.hybrids)
                    fieldKO.hybrid_selection(ho)

                    if field.refuge_hybrids_id
                        ho = new HybridOption({ id: field.refuge_hybrids_id }, @taffy.hybrids)
                        fieldKO.refuge_selection(ho)

                if field.low_yield_hybrids_id?
                    ho = new HybridOption({ id: field.low_yield_hybrids_id }, @taffy.hybrids)
                    fieldKO.low_yield_hybrid_selection(ho)

            @fields.push fieldKO

        # unset the currentFieldID from the SPP handler - it served its purpose
        @spp.currentFieldID = null
        delete @spp.currentFieldID

        if @fields.length and @spp.makes_recommendations
            doSPP = @spp.inputChanged or not @spp.finished
            @_queueFields(doSPP)


    ###########################################################################
    # This is where we process the requests to get the recommendations
    # We want to spread them out so we don't bog down our server. The number of
    # simultaneous requests is variable.
    #
    # I also hijacked window.debug to record profiling info for the requests as
    # needed, in part to be able to find the optimal number of simultaneous
    # requests when run on the server.
    #
    # TODO: abstract this out into a request manager class or something
    ###########################################################################
    _queueFields: (doSPP, i = 0) ->
        # set the number of simultaneous requests
        numRequests = 1
        if isDebug()
            numRequests = window.numRequests ? numRequests

        # this check shouldn't be necessary; it's just here for safety
        if i > @fields.length - 1
            debugLog("Error: Tried to get results for field index #{i}, but there are only #{@fields.length} fields")
            return

        field = @fields[i]

        if isDebug()
            if not @requestTimes?
                @requestTimes = []
                debugLog "num requests: #{numRequests}"
                @_startTime(this)

            @requestTimes[i] = obj =
                index: i
                id: field.id
            @_startTime(obj)

        postParams =
            id: @spp_id
            result_id: @results_id
            field_id: field.id
            do_spp: doSPP
        $.post 'backend/grower/placement/spp/get-recommendations', postParams, (response) =>
            field.handleResponse(response)

            if i + numRequests < @fields.length
                @_queueFields(doSPP, i + numRequests)

            if isDebug()
                obj = @requestTimes[i]
                @_endTime(obj)

                done = true
                for obj in @requestTimes
                    done = false if not obj?.endTime?

                if done
                    @_endTime(this)

                    times = []
                    sum = 0
                    for obj in @requestTimes
                        times.push parseInt obj.elapsedTime.getTime()
                        sum += times[times.length - 1]
                        debugLog "field #{obj.index}(#{obj.id}): #{obj.elapsedTimePretty}"

                    # Yes, the comparison function is necessary, because
                    # JavaScript is all like "herp derp, I'ma sort your numbers
                    # alphabetically!"
                    times.sort strnatcasecmp
                    debugLog "elapsed time: #{@elapsedTimePretty}"
                    debugLog "avg request: #{Math.round(sum / @fields.length)}ms"
                    debugLog "shortest request: #{times[0] ? null}ms"
                    debugLog "longest request: #{times[times.length - 1] ? null}ms"

        # start multiple requests on the first iteration, so that we can simply
        # send new requests as each response comes back
        if i is 0
            n = 1
            while n < numRequests and n < @fields.length
                @_queueFields(doSPP, n++)

    # a couple little functions to make profiling easier
    _startTime: (obj) ->
        now = new Date()
        obj.startTime = now
        obj.startTimePretty = now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds() + '.' + now.getMilliseconds()

    _endTime: (obj) ->
        now = new Date()
        elapsed = new Date(now - obj.startTime)

        obj.endTime = now
        obj.endTimePretty = now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds() + '.' + now.getMilliseconds()

        obj.elapsedTime = elapsed
        obj.elapsedTimePretty = elapsed.getMinutes() + ' min, ' + elapsed.getSeconds() + '.' + elapsed.getMilliseconds() + 's'


    ###########################################################################
    # Initialize all the KO properties and methods
    ###########################################################################
    _initKO: () ->
        # processing
        @processing = ko.observable(true)
        @processing.subscribe (processing) =>
            @handler.showCustomButtons()
        @doneProcessing = ko.observable(false)
        @showProceed = ko.computed () => @processing() and @doneProcessing()


        # fields
        @visibleFieldNum = ko.observable(@initialVisibleFieldNum)
        delete @initialVisibleFieldNum # no need for this anymore

        @visibleField = ko.computed () => @fields[@visibleFieldNum()]
        @visibleField.subscribe (field) =>
            @_setCurrentField(field.id)

        # plans
        @hasPlantingPlan = ko.computed () => @visibleField()?.planting_plan_id()?
        @hasRxPlan = ko.computed () => @visibleField()?.rx_plan_id()?
        @hasAPlan = ko.computed () => @hasPlantingPlan() or @hasRxPlan()

        @hybridsChanged = ko.computed () =>
            if not @hasPlantingPlan()
                return false

            field = @visibleField()
            if not field?
                return false

            plannedHybrids = field.plannedHybrids() ? []
            if not plannedHybrids.length
                return false

            plannedHybridID = plannedHybrids[0]?.hybridID ? null
            plannedRefugeID = plannedHybrids[1]?.hybridID ? null
            selectedHybridID = field.hybrid_selection()?.id ? null
            selectedRefugeID = field.refuge_selection()?.id ? null

            return (plannedHybridID isnt selectedHybridID or plannedRefugeID isnt selectedRefugeID)

        @plannedFields = ko.computed () =>
            arr = []
            for field, i in @fields
                if field.planting_plan_id()? or field.rx_plan_id()?
                    arr.push(i)
            return arr

        @plantingPlans = ko.computed () =>
            ids = []
            for field in @fields
                if field.rx_plan_id()? and field.hidden_planting_plan_id()?
                    ids.push field.hidden_planting_plan_id()
                else if field.planting_plan_id()?
                    ids.push field.planting_plan_id()
            return ids

        # recommendations
        @showSpinner = ko.computed () =>
            return @spp.makes_recommendations and @visibleField()?.showSpinner()
        @showError = ko.computed () => @visibleField()?.showError()

        # hybrids
        @visibleHybrids = ko.computed () => @visibleField()?.visibleHybrids() ? []
        @showHybrids = ko.computed () => @visibleHybrids().length > 0
        @canGetPrevHybrids = ko.computed () => @getPrevHybrids(true)
        @canGetNextHybrids = ko.computed () => @getNextHybrids(true)

        # low yield hybrids
        # TODO: this is bad. I shouldn't just be copy/pasting these...
        # we should probably create a hybrid result set class to manage this
        @visibleLowYieldHybrids = ko.computed () => @visibleField()?.visibleLowYieldHybrids() ? []
        @showLowYieldHybrids = ko.computed () => @visibleLowYieldHybrids().length > 0
        @canGetPrevLowYieldHybrids = ko.computed () => @getPrevLowYieldHybrids(true)
        @canGetNextLowYieldHybrids = ko.computed () => @getNextLowYieldHybrids(true)

        # refuge hybrids
        @visibleRefuges = ko.computed () => @visibleField()?.visibleRefuges() ? []
        @showRefuges = ko.computed () => @visibleRefuges().length > 0
        @canGetPrevRefuges = ko.computed () => @getPrevRefuges(true)
        @canGetNextRefuges = ko.computed () => @getNextRefuges(true)

        @refuge_mismatch = ko.computed () =>
            if @visibleField()?.hybrid_selection()?.refuge_options?.length > 0
                return false
            return @visibleField()?.hybrid_selection()?.requires_refuge

        # previous field button
        @prevBtnText = ko.computed () =>
            if @processing() or @visibleFieldNum() is 0
                return 'Back to Survey'
            return 'Previous Field'

        # next field button
        @showNext = ko.computed () =>
            return @visibleField()? and not @processing()

        @nextBtnText = ko.computed () =>
            if @isLastField()
                return 'Done'
            if not @hasPlantingPlan() and not @hasRxPlan()
                return 'Skip Field'
            return 'Next Field'

        # planting plan button
        @plantingDialogOpen = ko.observable(false)
        @showPlanting = ko.computed () =>
            return @visibleField()? and not @processing() and not @hasRxPlan()

        @plantingBtnText = ko.computed () =>
            if @hasPlantingPlan()
                if @hybridsChanged()
                    return 'Replace Planting Plan'
                return 'Edit Planting Plan'
            return 'Create Planting Plan'

        # rx plan button
        @showRx = ko.computed () =>
            if not @visibleField()? or @processing() or not @spp.enable_rx_plans
                return false
            if @hasPlantingPlan()
                return false

            rxPlanAspect = @spp.getFieldAspectByName(@visibleField().id, 'Create Rx Maps')
            return !!rxPlanAspect?.value

        @rxBtnText = ko.computed () =>
            if @hasRxPlan()
                # viewing rx doesn't work yet, so we just disable it for now
                # return 'View Rx Plan'
                return 'Rx Plan Created'
            return 'Create Rx Plan'

        # Convert to Rx button
        @showRxConvert = ko.computed () =>
            if not @visibleField()? or @processing() or not @spp.enable_rx_plans
                return false
            if @hasRxPlan() or not @hasPlantingPlan()
                return false

            rxPlanAspect = @spp.getFieldAspectByName(@visibleField().id, 'Create Rx Maps')
            return !!rxPlanAspect?.value


    _setCurrentField: (fieldID) ->
        # just send an ajax request to set the current field
        postParams =
            id: @spp_id
            result_id: @results_id
            field_id: fieldID

        $.post 'backend/grower/placement/spp/set-current-field', postParams, () ->
            # handle the request silently
            undefined


    createPlantingPlan: =>
        field = @visibleField()
        replace_hybrids = not @hasPlantingPlan() or @hybridsChanged()

        field.saveSeedSelection =>
            factory = new PlantingPlanFactory()
            factory.create(field, @handler, @spp, replace_hybrids)

            $(window).off('spp.planting-plan-saved')
            $(window).on 'spp.planting-plan-saved', (event, data) =>
                field.setPlantingPlan(
                    data.id
                    data.products
                    @taffy.hybrids
                    @selectionsKO
                    true
                )

                # this check is just here in case it's possible to switch
                # fields with the planting dialog open
                if field is @visibleField()
                    @nextField()

            $(window).off('spp.planting-plans-copied')
            $(window).on 'spp.planting-plans-copied', (event, data) =>
                if not data.plans?.length
                    return

                for plan in data.plans
                    # don't do anything for plans copied to other years
                    if plan.year isnt @spp.year
                        continue

                    copiedField = _.filter(@fields, { id: plan.fields_id })[0]
                    ###
                    products should be an array of objects with the properties:
                        id
                        fieldID
                        hybridName
                        treatmentID (optional)
                        treatmentName (optional)
                        units
                    ###
                    copiedField?.setPlantingPlan(
                        plan.id
                        plan.products.map (product) ->
                            id: product.id
                            fieldID: plan.fields_id
                            hybridName: product.hybrid_name
                            treatmentID: product.treatments_id
                            treatmentName: product.treatment_name
                            units: +product.units
                        @taffy.hybrids
                        @selectionsKO
                        false # planting plan is already set when copy happens
                    )


    convertPlanToRx: () =>
        field = @visibleField()

        statusFn = (status) =>
            if status?
                @writer.message_writer(status.type, status.msg, true)

        # we don't need to call saveSeedSelection first because we're using the
        # hybrids from the existing planting plan, which uses the same seed
        # company list
        (new PlantingToRxConverter()).create field, @spp, statusFn, (data) =>
            products = data.hybrids.map (product) ->
                fieldID: field.id
                hybridID: product.id
                hybridName: product.hybrids_name
                treatmentID: product.treatments_id
                treatmentName: product.treatments_name
                units: +product.units
            field.setRxPlan data.layers_id, data.planting_layers_id, products, @taffy.hybrids, @selectionsKO, true

            # field shouldn't change, but better safe than sorry
            if field is @visibleField()
                @nextField()


    createRxPlan: () =>
        field = @visibleField()

        field.saveSeedSelection =>
            (new RxPlanFactory()).create field, @spp, (data) =>
                products = data.hybrids.map (product) ->
                    fieldID: field.id
                    hybridID: product.id
                    hybridName: product.hybrids_name
                    treatmentID: product.treatments_id
                    treatmentName: product.treatments_name
                    units: +product.units
                field.setRxPlan data.layers_id, data.planting_layers_id, products, @taffy.hybrids, @selectionsKO, true

                # field shouldn't change, but better safe than sorry
                if field is @visibleField()
                    @nextField()


    # Step/Field interaction functions

    endProcessing: () ->
        @processing false
        $('.spp_header').html '<h3>Fit Seed to Field</h3>'
        $('.spp-units-display').show()
        @handler.setupDatatable()


    nextField: () ->
        # We have some fairly interesting logic here.
        #
        # If we're not already on the last field, then go to the next field,
        # unless we just created a planting plan for the last remaining field,
        # in which case we mark the survey as finished and show the dialog.
        #
        # If we are already on the last field, then if any of the fields don't
        # have planting plans, always show the "Skipped Fields" dialog. If all
        # the fields now have planting plans, on the other hand, mark the
        # survey as finished (if and only if it is not already finished) and
        # show the "Finished" dialog.
        #
        # Note that the "Skipped Fields" dialog will either take the user back
        # to the first skipped field, or mark the survey as finished and then
        # bring up the "Finished" dialog.
        # -SK
        if not @isLastField()
            if @plannedFields().length is @fields.length and not @spp.finished
                @finishSPP()
            else
                @visibleFieldNum( @visibleFieldNum() + 1 )

        else
            if @plannedFields().length isnt @fields.length
                @handler.showSkippedFieldsDialog()
            else
                if @spp.finished
                    @finishSPP(false)
                else
                    @finishSPP()


    prevField: () ->
        if @processing() or @visibleFieldNum() is 0
            @prevStep()
            return

        @visibleFieldNum( @visibleFieldNum() - 1 )


    prevStep: () ->
        @spp.goToStep(@handler.num - 1)


    isLastField: () ->
        return @visibleFieldNum() is (@fields.length - 1)


    firstSkippedFieldNum: () ->
        for field, i in @fields
            if not field.planting_plan_id()?
                return i
        return null


    goToFirstSkippedField: () ->
        num = @firstSkippedFieldNum()
        @visibleFieldNum(num) if num?


    finishSPP: (doAjax = true) ->
        if doAjax
            callback = () =>
                @handler.showFinishedDialog()
            @spp.finish(callback)
        else
            @handler.showFinishedDialog()


    # Hybrid button creation functions

    getHybridButtonClass: (hybrid) ->
        return @_getButtonClass hybrid, @visibleField()?.hybrid_selection()

    getLowYieldHybridButtonClass: (hybrid) ->
        return @_getButtonClass hybrid, @visibleField()?.low_yield_hybrid_selection()

    getRefugeButtonClass: (hybrid) ->
        return @_getButtonClass hybrid, @visibleField()?.refuge_selection()

    _getButtonClass: (hybrid, selected) ->
        if hybrid.id is selected?.id
            return @spanCls + ' btn-blue'
        else
            return @spanCls + ' btn-light-blue'

    getButtonContents: (hybrid) ->

        # The hybrid button contents definition is stored as a object in the
        # SPP Handler, made up of the attributes listed below. Generally, each
        # value is the name of a hybrid attribute that we grab the value of.
        # All attributes are optional and will appear in the order listed.


        # The "title" attribute is the first thing in the button. It contains
        # a single hybrid attribute, the value of which is displayed bolded

        # The "subtitle" attribute is the second thing in the button. Like the
        # "title" attribute, it contains a single hybrid attribute, but the value
        # is not bolded.

        # The "table" attribute is a key-value store, where the keys appear in
        # left-aligned with a colon, and the values are hybrid attributes, the
        # values of which appear after the key. For instance, if we have:
        #     obj.table = {"RM":"relative_maturity"}
        #     hybrid.relative_maturity = 104
        # it will be output as:
        #     '<div>RM: 104</div>'

        # The "text" attribute is an array containing hybrid attributes, the
        # values of which will simply appear as left-aligned text rows.
        # For instance, if we have:
        #     obj.text = ["talking_points_line_1"]
        #     hybrid.talking_points_line_1 = "Excellent stalk strength"
        # it will be output as:
        #     '<div>Excellent stalk strength</div>'


        # shorten this just because we use it a lot
        obj = @btnContents

        btnHTML = ''
        if obj.title? then btnHTML += '<div class="title">' + hybrid[obj.title] + '</div>'
        if obj.subtitle? then btnHTML += '<div class="subtitle">' + hybrid[obj.subtitle] + '</div>'

        # generate the table-based button contents if they exist
        if obj.table?
            # btnHTML += '<table>'
            # for key, val of obj.table
            #     btnHTML += '<tr><td>'+key+'</td><td>'+hybrid[val]+'</td></tr>'
            # btnHTML += '</table>'
            for key, val of obj.table
                buttonText = key + ': ' + (hybrid[val] ? 'N/A')
                buttonText = buttonText.replace("'", '&#39;')
                btnHTML += "<div class='nowrap' title='#{buttonText}'>#{buttonText}</div>"

        # generate the text-based button contents if they exist
        if obj.text?
            for str in obj.text
                btnHTML += '<div class="nowrap">' + (hybrid[str] ? '') + '</div>'

        return btnHTML


    # Hybrid interaction functions

    getNextHybrids: (checkOnly = false) => @visibleField()?.getNextHybrids(checkOnly)
    getPrevHybrids: (checkOnly = false) => @visibleField()?.getPrevHybrids(checkOnly)
    selectHybrid: (hybrid) => @visibleField()?.selectHybrid(hybrid)

    # TODO: this is bad. I shouldn't just be copy/pasting these...
    getNextLowYieldHybrids: (checkOnly = false) => @visibleField()?.getNextLowYieldHybrids(checkOnly)
    getPrevLowYieldHybrids: (checkOnly = false) => @visibleField()?.getPrevLowYieldHybrids(checkOnly)
    selectLowYieldHybrid: (hybrid) => @visibleField()?.selectLowYieldHybrid(hybrid)

    getNextRefuges: (checkOnly = false) => @visibleField()?.getNextRefuges(checkOnly)
    getPrevRefuges: (checkOnly = false) => @visibleField()?.getPrevRefuges(checkOnly)
    selectRefuge: (hybrid) => @visibleField()?.selectRefuge(hybrid)
